// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"cafec43d","90":"37b4045a","330":"7dda6903","417":"a430e93a","573":"0e111fa2","577":"33a860a8","604":"6ffb5d62","639":"3cc7be2d","647":"b9250718","796":"9444919d","983":"bfa4a730"}[chunkId] + ".chunk.js";
};